module.exports = __webpack_public_path__ + "img/dbfd437.jpg";